module.exports = __webpack_public_path__ + "media/promo/courses/images/reloadbg-cc6f699bcc6629b86492f011e8d300d5.jpg";